import { STATUS } from "@constants/status.eTicket";

const { ON_GOING, CLOSED, PENDING, SOLVED } = STATUS;

export const statusENUM = [
  {
    id: 0,
    label: "Pending",
    value: PENDING,
  },
  {
    id: 1,
    label: "On Going",
    value: ON_GOING,
  },
  {
    id: 2,
    label: "Solved",
    value: SOLVED,
  },
  {
    id: 3,
    label: "Closed",
    value: CLOSED,
  },
];
